import { DisplayAuthoringPropertyPipe, InheritPipe, IsRequiredPropertyPipe } from '@adaptiva/metadata/common';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { ListBuilderComponentModule } from '@adaptiva/widgets/list-builder';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule, PipeTransform, Type } from '@angular/core';
import { AuthoringPropertyLabelComponentModule } from '../authoring-property-label-component';
import { UserPortalPropertiesComponent } from './user-portal-properties.component';

const WIDGETS: Type<any>[] = [
	AuthoringPropertyLabelComponentModule,
	CardComponentModule,
	ContainerComponentModule,
	InputComponentModule,
	ListBuilderComponentModule,
	TextComponentModule,
];

const PIPES: Type<PipeTransform>[] = [
	DisplayAuthoringPropertyPipe,
	IsRequiredPropertyPipe,
	InheritPipe,
];

@NgModule({
	imports: [
		CommonModule,
		PIPES,
		WIDGETS
	],
	declarations: [UserPortalPropertiesComponent],
	exports: [UserPortalPropertiesComponent]
})
export class UserPortalPropertiesComponentModule {

}
